import { LinkAction } from '@leverege/molten/routes';
import { Config } from '@leverege/plugin';
import { Routes, Types } from "../../constants/index.js";
export default LinkAction.create({
  id: 'leverege.fotaApi.link.device.info',
  matches: {
    use: 'navBar',
    client: 'ItemScreen',
    objectType: Types.device,
    path: 'leverege.fotaApi.device'
  },
  path: Routes.rootDeviceItemInfo,
  name: 'Overview',
  layout: {
    // group() {
    //   return Config.get( 'LeveregeFota', 'rootLinkGroup', [ 'fota' ] )
    // },
    // groupNames() {
    //   return Config.get( 'LeveregeFota', 'rootLinkGroupNames', [ 'Fota' ] )
    // },
    // groupIcons() {
    //   return Config.get(
    //     'LeveregeFota',
    //     'rootLinkGroupIcons',
    //     [ 'https://storage.googleapis.com/molten-ui-assets/icon-center-objects.png' ]
    //   )
    // },
    sort() {
      return Config.get('LeveregeFota', 'rootDeviceItemInfoLinkSort', 'aaa');
    }
  },
  icon: () => Config.get('LeveregeFota', 'deviceItemInfoNavIcon')
});